
<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-row>
                    <b-col cols="12">
                        <b-form-group :label="$t('date')">
                            <b-input-group >
                                <div class="label-as-input">{{ isNotNullValue(form.created_at) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group :label="$t('subject')">
                            <b-input-group >
                                <div class="label-as-input">{{ isNotNullValue(form.subject) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group :label="$t('from')">
                            <b-input-group >
                                <div class="label-as-input">{{ isNotNullValue(form.from) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group :label="$t('to')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(form.to) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group :label="$t('cc')">
                            <b-input-group >
                                <div class="label-as-input">{{ isNotNullValue(form.cc) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group :label="$t('bcc')">
                            <b-input-group>
                                <div class="label-as-input">{{ isNotNullValue(form.bcc) }}</div>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>

            <b-col cols="12">
                <b-form-group :label="$t('body')">
                    <b-input-group>
                        <div class="label-as-input" v-html="isNotNullValue(form.body)"></div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>
<script>

export default {
    name: "DetailForm",
    props: {
        form: null
    },
    data(){
        return {

        }
    }
}
</script>
